/**
 * @generated SignedSource<<b2c565b71fe21be732cc324b3f9a2bed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerInfo_viewer$data = {
  readonly suppressNewSellerSignals: boolean | null;
  readonly " $fragmentType": "PdpSharedDealerInfo_viewer";
};
export type PdpSharedDealerInfo_viewer$key = {
  readonly " $data"?: PdpSharedDealerInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerInfo_viewer",
  "selections": [
    {
      "alias": "suppressNewSellerSignals",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "suppressNewSellerSignals"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ad0f9dc014f1edb5818d7f0fd2e602b0";

export default node;
